import { render, staticRenderFns } from "./SpectrumLook.vue?vue&type=template&id=3c486014&scoped=true"
import script from "./SpectrumLook.vue?vue&type=script&lang=js"
export * from "./SpectrumLook.vue?vue&type=script&lang=js"
import style0 from "./SpectrumLook.vue?vue&type=style&index=0&id=3c486014&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c486014",
  null
  
)

export default component.exports